import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  IconButton,
} from "@mui/material";
import { useLazyGetMyNotificationsQuery } from "../../service/notifications";
import { MyNotification } from "../../types/General";
import Pagination from "../../components/Panigation";
import { NOTIFICATION_TYPE } from "../../constants/enums";
const RecievedNotifications = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [notifications, setNotifications] = useState<MyNotification[]>([]);
  const [getMyNotifications] = useLazyGetMyNotificationsQuery();

  const getNotifications = async () => {
    try {
      const response = await getMyNotifications({
        page,
        limit,
        search: searchTerm,
      }).unwrap();
      if (response.data) {
        setNotifications(response?.data?.list || []);
        setTotalCount(response?.data?.totalCount || 0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    getNotifications();
  };

  useEffect(() => {
    getNotifications();
  }, [page, limit, searchTerm]);

  const totalPages = Math.ceil(totalCount / limit);

  return (
    <>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Recieved Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
        </div>
        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="v3"
          >
            <TableHead>
              <TableRow hover>
                <TableCell>User Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Date</TableCell>
                {/* <TableCell>Action</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {notifications.map((notification) => (
                <TableRow hover>
                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img src="/static/images/user_placeholder.png" alt="" />
                      </figure>
                      <p>
                        <b>{notification.sendBy}</b>
                        {/* <span>{notification.user_email}</span> */}
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>
                    {NOTIFICATION_TYPE[
                      notification?.type as keyof typeof NOTIFICATION_TYPE
                    ] || notification?.type}
                  </TableCell>
                  <TableCell>{notification.title}</TableCell>
                  <TableCell className="max_c2">
                    <p>{notification.content}</p>
                  </TableCell>
                  <TableCell>
                    {new Date(notification.createdAt).toLocaleDateString(
                      "en-GB"
                    )}
                  </TableCell>
                  {/* <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell> */}
                </TableRow>
              ))}
              {notifications.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No notifications found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {totalCount > 0 && (
        <Pagination
          module={notifications}
          page={page}
          onPageChange={handlePageChange}
          totalPages={totalPages}
          setPage={setPage}
          totalCount={totalCount}
        />
      )}
    </>
  );
};

export default RecievedNotifications;
